import useAPI from '@/hooks/useAPI';
import RequestedDocumentRepository from '@/repositories/RequestedDocumentRepository';

export const useRequestedDocument = (personId: string) => {
  const repository = RequestedDocumentRepository();

  return useAPI({
    queryKey: ['getRequestedDocumentData', personId],
    queryFn: async () => {
      return await repository.listByIdPaginated({ id: personId });
    },
    enabled: !!personId
  });
};
